export const SIGN_IN_MENU_ITEMS = [
  { label: "Profile", link: "/profile" },
  { label: "Favorite Charities", link: "/profile/favorites" },
  { label: "Donation History", link: "/profile/donation-history" },
  { label: "Recurring Donations", link: "/profile/donation-subscriptions" },
  { label: "Sign Out", link: "/auth/logout" },
];
